import * as React from 'react';
import { TouchableOpacity } from 'react-native';
import { CouponProps } from 'src/common/api/response';
import { formatDate } from 'src/common/utils/DateHelper';
import { CardContainer, RegularText } from 'src/components';
import { metrics } from 'src/themes/Metrics';

export const CouponItem = ({ item, onPress }: { item: CouponProps; onPress: (coupon: CouponProps) => void }) => {
  return (
    <TouchableOpacity style={{ marginBottom: metrics.medium }} activeOpacity={0.8} onPress={() => onPress(item)}>
      <CardContainer>
        <RegularText fontWeight="bold">{item.name}</RegularText>
        <RegularText fontWeight="bold">{formatDate(item.expiredAt)}</RegularText>
      </CardContainer>
    </TouchableOpacity>
  );
};
